import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, vShow as _vShow, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7bb5523c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "register-form-row" }
const _hoisted_3 = {
  value: "",
  selected: ""
}
const _hoisted_4 = ["value"]
const _hoisted_5 = ["value"]
const _hoisted_6 = ["value"]
const _hoisted_7 = ["value"]
const _hoisted_8 = { value: "other" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form__arrow" }, null, -1))
const _hoisted_10 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_11 = { class: "register-form-row" }
const _hoisted_12 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_13 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_14 = { class: "register-form-checkboxes" }
const _hoisted_15 = {
  for: "terms",
  class: "checkbox"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "checkbox-switch" }, null, -1))
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = {
  key: 0,
  class: "error-msg error-msg--alt"
}
const _hoisted_19 = { class: "register-form-foot register-form-foot--alt" }
const _hoisted_20 = {
  key: 1,
  type: "button",
  disabled: "",
  class: "button button--loading"
}
const _hoisted_21 = {
  key: 0,
  class: "error-msg error-msg--alt error-msg--right t-list"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonHover = _resolveComponent("ButtonHover")!

  return (_openBlock(), _createElementBlock("form", {
    class: "register-form form",
    onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
  }, [
    _createElementVNode("h3", {
      class: "register-form-title h4",
      innerHTML: _ctx.$t('staff-form.step3-description')
    }, null, 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('staff-form.question')), 1),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.hear) = $event)),
          onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$.hear.$touch && _ctx.v$.hear.$touch(...args))),
          class: _normalizeClass({ 'error': _ctx.v$.hear.$errors.length }),
          name: "hear"
        }, [
          _createElementVNode("option", _hoisted_3, _toDisplayString(_ctx.$t('register-form.select')), 1),
          _createElementVNode("option", {
            value: _ctx.$t('staff-form.item1')
          }, _toDisplayString(_ctx.$t('staff-form.item1')), 9, _hoisted_4),
          _createElementVNode("option", {
            value: _ctx.$t('staff-form.item2')
          }, _toDisplayString(_ctx.$t('staff-form.item2')), 9, _hoisted_5),
          _createElementVNode("option", {
            value: _ctx.$t('staff-form.item3')
          }, _toDisplayString(_ctx.$t('staff-form.item3')), 9, _hoisted_6),
          _createElementVNode("option", {
            value: _ctx.$t('staff-form.item4')
          }, _toDisplayString(_ctx.$t('staff-form.item4')), 9, _hoisted_7),
          _createElementVNode("option", _hoisted_8, _toDisplayString(_ctx.$t('staff-form.item5')), 1)
        ], 34), [
          [_vModelSelect, _ctx.hear]
        ]),
        _hoisted_9,
        (_ctx.v$.hear.$errors.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.v$.hear.$errors[0].$message), 1))
          : _createCommentVNode("", true)
      ]),
      _withDirectives(_createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('staff-form.how')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.how) = $event)),
          type: "text",
          name: "how",
          spellcheck: "false",
          autocapitalize: "off",
          autocorrect: "off"
        }, null, 512), [
          [_vModelText, _ctx.how]
        ])
      ], 512), [
        [_vShow, _ctx.hear === 'other']
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('staff-form.participants')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.participants) = $event)),
          onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.v$.participants.$touch && _ctx.v$.participants.$touch(...args))),
          class: _normalizeClass({ 'error': _ctx.v$.participants.$errors.length }),
          type: "number",
          name: "participants",
          required: "",
          spellcheck: "false",
          autocapitalize: "off",
          autocorrect: "off"
        }, null, 34), [
          [
            _vModelText,
            _ctx.participants,
            void 0,
            { number: true }
          ]
        ]),
        (_ctx.v$.participants.$errors.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.v$.participants.$errors[0].$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('staff-form.referred')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.referred) = $event)),
          type: "text",
          name: "referred",
          spellcheck: "false",
          autocapitalize: "off",
          autocorrect: "off"
        }, null, 512), [
          [_vModelText, _ctx.referred]
        ])
      ])
    ]),
    _createElementVNode("fieldset", null, [
      _createElementVNode("legend", null, _toDisplayString(_ctx.$t('staff-form.staff')), 1),
      _withDirectives(_createElementVNode("textarea", {
        maxlength: "3000",
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.reason) = $event)),
        onBlur: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.v$.reason.$touch && _ctx.v$.reason.$touch(...args))),
        class: _normalizeClass({ 'error': _ctx.v$.reason.$errors.length }),
        name: "reason",
        required: "",
        rows: "4"
      }, null, 34), [
        [_vModelText, _ctx.reason]
      ]),
      _withDirectives(_createElementVNode("span", { class: "char-counter" }, _toDisplayString(_ctx.reason.length +'/3000'), 513), [
        [_vShow, _ctx.reason.length != 0]
      ]),
      (_ctx.v$.reason.$errors.length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.v$.reason.$errors[0].$message), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("label", _hoisted_15, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.terms) = $event)),
          name: "terms",
          id: "terms",
          type: "checkbox"
        }, null, 512), [
          [_vModelCheckbox, _ctx.terms]
        ]),
        _hoisted_16,
        _createElementVNode("span", {
          class: "checkbox-label text",
          innerHTML: _ctx.$t('staff-form.optin-terms', {terms: '/terms', privacy: 'https://privacy.pernod-ricard-usa.com/'})
        }, null, 8, _hoisted_17)
      ]),
      (_ctx.isSubmit && !_ctx.terms)
        ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_ctx.$t('error.terms')), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("button", {
        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('prevTab'))),
        type: "button",
        class: "link-secondary text-lg"
      }, _toDisplayString(_ctx.$t('register-form.back')), 1),
      _createElementVNode("div", null, [
        (!_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_ButtonHover, {
              key: 0,
              type: "submit",
              class: "button"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('register-form.submit')), 1)
              ]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock("button", _hoisted_20, _toDisplayString(_ctx.$t('register-form.loading')), 1))
      ])
    ]),
    (_ctx.errors)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_21, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (item, i) => {
            return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(item), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 32))
}